import { render } from "./card.vue?vue&type=template&id=4c0eb2c8"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
script.render = render

export default script